import React, { useState, useEffect, useCallback } from "react";
import BlogBoard from "src/components/home/BlogBoard";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";
import { ListParam, defaultListParam } from "src/types/api/listParam";
import { getBlogAmount, getBlogLatest } from "src/api/BlogApi";

interface BlogContainerProps {
  rowPerPage: number;
}

const BlogContainer: React.FC<BlogContainerProps> = ({ rowPerPage }) => {
  const [blogcontents, setBlogContents] = useState([]);
  const blogTab = useSelector((state: RootState) => state.tab.blogTab);
  const [curPage, setCurPage] = useState(null);
  const [isMore, setIsMore] = useState(true);
   
  const fetchData = useCallback(async (params: ListParam) => {
    try{
      let response;
      
      if (blogTab === "최신"){
        response = await getBlogLatest(params);
      }
      else if (blogTab === "누적"){
        response = await getBlogAmount(params);
      }
  
      const newData = response?.data?.list || [];
      if ( newData.length < rowPerPage ){
        setIsMore(false)
      } else {
        setIsMore(true)
      }
      if (params.curPage === 1) {
        setBlogContents(newData);
      } else {
        setBlogContents((prevData) => [...prevData, ...newData]); 
      }
    } catch (error) {
        console.error("API 호출 실패:", error);
        if (params.curPage === 1) setBlogContents([]);
    }
  }, [rowPerPage, blogTab]);
      
  useEffect(() => {
      setCurPage(null);
      const defaultParams = defaultListParam();
      defaultParams.rowPerPage = rowPerPage;
      fetchData(defaultParams);
  }, [blogTab, rowPerPage, fetchData]);

  const handleLoadMore = async () => {
    try {
      const defaultParams = defaultListParam();
      const newPage = curPage === null ? 2 : curPage + 1;
      defaultParams.curPage = newPage
      defaultParams.rowPerPage = rowPerPage
      await fetchData(defaultParams);
      setCurPage(newPage);
    } catch (error) {
        console.error("추가 데이터 로드 실패:", error);
    }
  };
  return (
    <BlogBoard contents={blogcontents} isMore={isMore} handleLoadMore={handleLoadMore} />
  );
};

export default BlogContainer;
